var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_359_870)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 41,
    height: 41
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4756,
    y: 13.4219,
    width: 39.5786,
    height: 39.5786,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3699 46.4033C20.5559 46.4033 19.0029 45.7574 17.7111 44.4656C16.4193 43.1738 15.7734 41.6209 15.7734 39.8069V26.614C15.7734 24.8 16.4193 23.2471 17.7111 21.9553C19.0029 20.6635 20.5559 20.0176 22.3699 20.0176H42.1592C43.9732 20.0176 45.5261 20.6635 46.8179 21.9553C48.1097 23.2471 48.7556 24.8 48.7556 26.614V39.8069C48.7556 41.6209 48.1097 43.1738 46.8179 44.4656C45.5261 45.7574 43.9732 46.4033 42.1592 46.4033H22.3699ZM22.3699 26.614H42.1592C42.7639 26.614 43.341 26.6827 43.8907 26.8202C44.4404 26.9576 44.9627 27.1775 45.4574 27.4798V26.614C45.4574 25.707 45.1344 24.9305 44.4885 24.2846C43.8426 23.6387 43.0662 23.3158 42.1592 23.3158H22.3699C21.4629 23.3158 20.6864 23.6387 20.0405 24.2846C19.3946 24.9305 19.0717 25.707 19.0717 26.614V27.4798C19.5664 27.1775 20.0886 26.9576 20.6383 26.8202C21.188 26.6827 21.7652 26.614 22.3699 26.614ZM19.319 31.9736L37.6654 36.4262C37.9127 36.4812 38.1601 36.4812 38.4075 36.4262C38.6548 36.3712 38.8884 36.2613 39.1083 36.0964L44.839 31.314C44.5366 30.9017 44.1519 30.565 43.6846 30.3039C43.2174 30.0428 42.7089 29.9122 42.1592 29.9122H22.3699C21.6553 29.9122 21.03 30.0978 20.494 30.4688C19.9581 30.8399 19.5664 31.3415 19.319 31.9736Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_870",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B7F133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIconGreen);
export default __webpack_public_path__ + "static/media/wallet-icon-green.6e739bd0d0a11fa3478bc6b617708419.svg";
export { ForwardRef as ReactComponent };